<template>
  <div class="h-full w-full">
    <!-- <div class="block absolute bottom-20 left-6 shadow-2xl">
      <div
        :style="{ 'background-color': debugColor }"
        class="flex items-center justify-start text-white text-sm font-medium space-x-2 bg-ontick-steel-500 ease-in-out duration-300"
      >
        <div class="flex flex-col px-4 py-2">
          <span class="text-white text-xs font-bold">
            {{ contextUuid }}
          </span>
          <span class="text-white text-xs font-medium"> {{ ticker }} | {{ timeframe }} </span>
        </div>
        <div class="flex pr-2 space-x-1">
          <button
            @click="debugColor = colors[Math.floor(Math.random() * colors.length)]"
            class="h-full py-2 px-4 bg-ontick-steel-500 text-white text-xs font-medium hover:scale-110 ease-in-out duration-300"
          >
            debug color
          </button>
        </div>
      </div>
    </div> -->
    <div :ref="divChart" :id="chartContainer" class="h-full w-full"></div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import { mapActions, mapGetters } from "vuex";
import { ConvertTimeframe } from "../utils";
import Datafeed from "../datafeed";
import OntickEditableSelectComponent from "../../../shared/components/basic/ontick-editable-select.component.vue";
import ChartHeader from "../components/chart-header.component.vue";
import EventBus from "../../../shared/utils/event_bus";
import configurationData from "../configurationData";

const colors = [
  "#dc2626",
  "#ea580c",
  "#d97706",
  "#ca8a04",
  "#16a34a",
  "#0d9488",
  "#0284c7",
  "#2563eb",
  "#4f46e5",
  "#7c3aed",
  "#9333ea",
  "#c026d3",
  "#db2777",
  "#e11d48",
];

export default {
  name: "portfolio-chart-grid",
  components: {
    OntickEditableSelectComponent,
    ChartHeader,
  },
  props: {
    // datafeed: {
    //   type: Object,
    // },
    ticker: {
      type: String,
      default: "WINFUT",
    },
    timeframe: {
      type: String,
      default: "M15",
    },
    investmentId: {
      type: Number,
      default: 0,
    },
    selectedStrategy: {
      type: Object,
    },
  },
  data() {
    return {
      debugColor: colors[Math.floor(Math.random() * colors.length)],
      colors: colors,
      chartContainer: uuidv4(),
      widget: null,
      divChart: uuidv4(),
      cacheTicker: "WINFUT",
      defaultTimeframe: "M15",
      availableSymbols: ["WINFUT", "WDOFUT", "CCMFUT", "BITFUT"],
      positions: [],
      contextUuid: uuidv4(),
      connectionStatus: {
        awaitingConnection: false,
        retries: 0,
        error: false,
      },
      markerDate: {
        startDate: null,
        endDate: null,
        investmentIdUpdated: false,
      },
      arrayHorizontalLine: [],
      arrayExecutionShape: [],
      arrayMultipointShape: [],
      activeUpdate: false,
      updateIcon: {
        active: `<svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
        disabled: `<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="currentColor"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>`,
      },
      // usado para verificar se o ativo selecionado é igual ao ativo da estratégia selecionada.
      // caso não seja, não devo mostrar os markers.
      isActiveSelectedStrategy: true,
    };
  },
  computed: {
    ...mapGetters({
      getWebsocketIsConnected: "config/getWebsocketIsConnected",
      selectedAccount: "accountTypes/getSelectedAccount",
      strategies: "performance/getStrategies",
      marketdata: "marketdata/getMarketdata",
    }),
  },
  watch: {
    selectedStrategy: {
      deep: true,
      handler(value) {
        // console.log("WATCH selectedStrategy", value);
        this.isActiveSelectedStrategy = value.investment_symbol === this.ticker; // Checa se é o ativo da estratégia selecionada.
        return value;
      },
    },
    marketdata: {
      deep: true,
      handler(value) {
        // console.log("WATCH marketdata", value);
        return value;
      },
    },
    investmentId: {
      deep: true,
      handler(value) {
        // console.log("WATCH investmentId", value);
        this.markerDate.investmentIdUpdated = true;
        this.widget?.onChartReady(async () => {
          this.changeTimeframeInDatafeed(this.timeframe);
          this.widget?.activeChart().setResolution(ConvertTimeframe.toTradingView(this.timeframe), () => {
            setTimeout(() => this.renameDisplayTimeframe(this.timeframe), 1000);
          });
          this.listInvestment();
        });
        return value;
      },
    },
    ticker: {
      deep: true,
      handler(value, oldValue) {
        this.isActiveSelectedStrategy = this.selectedStrategy.investment_symbol === value;
        setTimeout(() => {
          // console.log("WATCH ticker", value);
          this.markerDate.investmentIdUpdated = true;
          this.widget?.onChartReady(() => {
            // Reseta cache dos dados histórico e redesenha o gráfico.
            this.resetHistoricalDataAndRedrawChart(oldValue, this.timeframe);
            this.changeSymbol(value);
          });
          // if (["CCMFUT", "BITFUT"].includes(value)) {
          //   this.timeframe = "M15";
          // }
          // EventBus.$emit("RESTART_CONSUMER");
        }, 1000);
        return value;
      },
    },
    timeframe: {
      deep: true,
      handler(value, oldValue) {
        // console.log("WATCH timeframe", value);
        this.markerDate.investmentIdUpdated = true;
        // Aparentemente não teve dano sem o setTimeout.
        // setTimeout(() => {
        this.widget?.onChartReady(() => {
          // Reseta cache dos dados histórico e redesenha o gráfico.
          this.resetHistoricalDataAndRedrawChart(this.ticker, oldValue);
          this.changeTimeframeInDatafeed(value);
          this.widget?.activeChart().setResolution(ConvertTimeframe.toTradingView(value), () => {
            setTimeout(() => this.renameDisplayTimeframe(value), 1000);
          });
          // this.changeSymbol(this.ticker, value);
        });
        // });
        return value;
      },
    },
    strategies: {
      deep: true,
      handler(value) {
        // console.log("WATCH strategies", value);
        return value;
      },
    },
    selectedAccount: {
      deep: true,
      handler(value) {
        // console.log("WATCH selectedAccount", value);
        this.fetchAccounts(value);
        return value;
      },
    },
  },
  async mounted() {
    this.$emit("contextUuid", this.contextUid);

    this.listInvestment();

    setTimeout(() => {
      this.buildChart();
      this.loadVolume();
      this.loadChartStyle();

      this.widget?.onChartReady(() => {
        setTimeout(() => EventBus.$emit("RESTART_CONSUMER"), 1000);
      });
    }, 500);

    EventBus.$on("DATAFEED_RENAME_DISPLAY_TIMEFRAME", (e) => {
      // this.logEvent("DATAFEED_RENAME_DISPLAY_TIMEFRAME");
      this.renameDisplayTimeframe();
    });

    EventBus.$on("REALTIME_TO_PORTFOLIO_CHART_GRID", ({ symbol, data }) => {
      if (symbol === this.ticker && data.timeframe === this.timeframe) {
        // console.log(
        //   "%c[%s:%s]",
        //   "font-size:12px;font-weight:bold;background:" + this.debugColor + ";padding:4px;",
        //   symbol,
        //   data.timeframe,
        //   this.contextUuid
        // );
        EventBus.$emit("DATAFEED_REALTIME_TICKER_CHART", {
          symbol,
          data,
          timeframe: this.timeframe,
          contextUuid: this.contextUuid,
          styleDebugColor: this.debugColor,
        });
      }
    });

    EventBus.$emit("DATAFEED_MAP_CHART", {
      symbol: this.ticker,
      timeframe: this.timeframe,
      contextUuid: this.contextUuid,
    });

    EventBus.$on("SUBSCRIBE_CHART", (e) => {
      if (this.widget?.activeChart()) {
        // this.logEvent("SUBSCRIBE_CHART portfolio-chart-grid");
        EventBus.$emit("RESTART_CONSUMER", e.emptyBars);
      }
    });
    EventBus.$on("UNSUBSCRIBE_CHART", (e) => {
      // this.logEvent("UNSUBSCRIBE_CHART");
    });

    this.widget?.onChartReady(() => {
      this.changeTimeframeInDatafeed(this.timeframe);
    });

    EventBus.$on("CLEAR_MARKERS", () => {
      if (this.widget?.activeChart()) {
        setTimeout(() => this.clearMarkers(), 1500);
      }
    });
    EventBus.$on("RESTART_MARKERS", async () => {
      if (this.widget?.activeChart()) {
        // this.logEvent("RESTART_MARKERS");
        await this.update();
        setTimeout(() => EventBus.$emit("STOP_BTN_UPDATE_MARKERS"), 1000);
      }
    });
    EventBus.$on("DATAFEED_RECEIVE_MARKERS", (e) => {
      if (this.widget?.activeChart()) {
        // this.logEvent("DATAFEED_RECEIVE_MARKERS");

        const { startDate, endDate, symbolInfo, investmentId } = e;

        if (symbolInfo.name !== this.ticker) {
          // Ativos diferentes, não devem ser renderizados
          return;
        }

        if (!this.markerDate.investmentIdUpdated) {
          // não atualizou o investmentId
          if (this.markerDate.startDate === startDate && this.markerDate.endDate === endDate) {
            // está requisitando o mesmo perído de markers
            return;
          }
        } else {
          // atualizou o investmentId
          this.markerDate.investmentIdUpdated = false;
        }

        this.markerDate.startDate = startDate;
        this.markerDate.endDate = endDate;

        this.update();
      }
    });
  },
  destroyed() {
    EventBus.$emit("DATAFEED_REMOVE_CONTEXTUUID", this.contextUuid);
    if (this.widget !== null) {
      this.widget.remove();
      this.widget = null;
    }
  },
  methods: {
    ...mapActions({
      fetchAccounts: "performance/fetchAccounts",
    }),
    logEvent(msg) {
      const isLocalhost = Boolean(
        window.location.hostname === "localhost" ||
          // [::1] is the IPv6 localhost address.
          window.location.hostname === "[::1]" ||
          // 127.0.0.1/8 is considered localhost for IPv4.
          window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
      );
      if (isLocalhost) {
        console.log(
          "%c[RECEIVED]<<<%s>>>",
          "font-size:18px;font-weight:bold;color:yellow;border:2px solid red;padding:8px;",
          msg
        );
      }
    },
    buildChart() {
      this.widget = new TradingView.widget({
        ...configurationData,
        container: this.chartContainer,
        datafeed: Datafeed,
        symbol: this.ticker,
        interval: ConvertTimeframe.toTradingView(this.timeframe),
        width: this.$refs[this.divChart].clientWidth,
        height: this.$refs[this.divChart].clientWidth,
      });
    },
    renameDisplayTimeframe(tf) {
      let chart = document.getElementById(this.chartContainer);
      if (chart?.getElementsByTagName("iframe")[0]) {
        chart
          ?.getElementsByTagName("iframe")[0]
          ?.contentWindow.document.body.querySelectorAll("div.title-l31H9iuA")
          ?.forEach((item) => {
            if (
              ConvertTimeframe.toTradingView(this.timeframe) === item.innerHTML ||
              this.timeframe === item.innerHTML
            ) {
              item.innerHTML = tf ? tf : this.timeframe;
            }
          });
      }
    },
    changeSymbol(symbol, timeframeOptional = null) {
      const tf = timeframeOptional != null ? timeframeOptional : this.timeframe;
      this.widget?.onChartReady(() => {
        this.widget.setSymbol(symbol, ConvertTimeframe.toTradingView(tf), () => {});
        EventBus.$emit("DATAFEED_MAP_CHART", {
          symbol,
          timeframe: tf,
          contextUuid: this.contextUuid,
        });
      });
    },
    clearMarkers() {
      this.widget?.onChartReady(() => {
        // Limpar tooltip com tipo e preço
        this.arrayExecutionShape?.forEach((item) => item.remove());
        this.arrayExecutionShape = [];

        // Limpar linha horizontal
        this.arrayHorizontalLine?.forEach((item) => item.remove());
        this.arrayHorizontalLine = [];

        // Limpar linha que conecta dois candles
        this.arrayMultipointShape?.forEach((item) => {
          this.widget?.activeChart().removeEntity(item);
        });
        this.arrayMultipointShape = [];

        // Limpar linha vertical
        this.widget?.activeChart().removeAllShapes();

        // Limpar marks
        this.widget?.activeChart().clearMarks();
      });
    },
    changeTimeframeInDatafeed(timeframe) {
      EventBus.$emit("DATAFEED_CHANGE_TIMEFRAME", { timeframe, contextUuid: this.contextUuid });
    },
    listInvestment() {
      this.widget?.onChartReady(() => {
        this.widget?.activeChart().resetData();
      });

      EventBus.$emit("DATAFEED_MARKERS_INVESTMENT_ID", {
        investment_id: Number.parseInt(this.investmentId, 10),
      });

      if (this.investmentId === 0) {
        this.clearMarkers();
        return;
      }

      this.cacheTicker = this.ticker;
      this.changeSymbol(this.ticker);
    },
    loadVolume() {
      this.widget?.onChartReady(() => {
        this.widget?.chart().createStudy("Volume", true, false, undefined, {});
      });
    },
    loadChartStyle() {
      // let { green, red } = this.$colors;
      // let positive = green[600];
      // let negative = red[600];
      this.widget?.onChartReady(() => {
        this.widget?.chart().getSeries().setChartStyleProperties(1, {
          // -
          // upColor: "#10F9E0",
          // downColor: "#1029F9",
          // borderDownColor: "#1029F9",
          // borderUpColor: "#10F9E0",
          // wickDownColor: "#1029F9",
          // wickUpColor: "#10F9E0",
          // -
          // upColor: positive,
          // downColor: negative,
          // borderDownColor: negative,
          // borderUpColor: positive,
          // wickDownColor: negative,
          // wickUpColor: positive,
        });
      });
    },
    widgetHorizontalLine(arr) {
      arr?.forEach((item) => {
        const identifier = item.uuid.split(":")[0];
        let hColor = "#0694e6";
        let hFontColor = "#ffffff";
        if (identifier === "TP") hColor = "#17c177";
        if (identifier === "SL") hColor = "#dd5b5b";
        var hLine = this.widget
          .chart()
          .createOrderLine()
          .setLineStyle(0) // [LineStyle] - 0=Solid | 1=Dotted | 2=Dashed
          .setBodyBackgroundColor(hColor)
          .setLineActiveBuyColor(hColor)
          .setLineActiveSellColor(hColor)
          .setBodyTextActiveBuyColor(hFontColor)
          .setBodyTextActiveSellColor(hFontColor)
          .setBodyBorderActiveBuyColor(hColor)
          .setBodyBorderActiveSellColor(hColor)
          .setQuantityBorderActiveBuyColor(hColor)
          .setQuantityBorderActiveSellColor(hColor)
          .setQuantityBackgroundActiveBuyColor(hColor) //se direction igual a "buy"
          .setQuantityBackgroundActiveSellColor(hColor) //se direction igual a "sell"
          .setDirection(item.type === "compra" ? "buy" : "sell")
          .setText(item.comment)
          .setTooltip(item.comment)
          .setLineLength(3)
          .setQuantity(item.volume)
          .setPrice(item.price);
        this.arrayHorizontalLine.push(hLine);
      });
    },
    listMarkers(startDate, endDate) {
      const uri = `${this.$endpoint.GET_MARKERS}/${this.investmentId}?start_date=${startDate}&end_date=${endDate}`;
      return new Promise(async (resolve, reject) => {
        await this.$api
          .get(uri)
          .then((response) => resolve(response.data))
          .catch((error) => reject(error));
      });
    },
    async update() {
      this.clearMarkers();

      if (this.investmentId === 0) {
        // Se investmentId === 0, é porque o dropdown selecionado é "Selecione uma estratégia".
        // Renderiza apenas o gráfico, sem markers, para que o usuário possa navegar à vontade.
        return;
      }

      if (!this.isActiveSelectedStrategy) {
        // Senão é ativo da estratégia selecionada, então devo remover os markers.
        return;
      }

      try {
        const { startDate, endDate } = this.markerDate;

        if (startDate === null || endDate === null) {
          return;
        }

        const response = await this.listMarkers(startDate, endDate);

        const { open, closed } = response;

        closed?.forEach((item) => {
          const executionShape1 = this.widget
            ?.activeChart()
            .createExecutionShape()
            .setText(`${item.entry.type}: ${item.entry.price}`)
            .setTextColor("#FCEB3C")
            .setArrowBuyColor("#FCEB3C")
            .setArrowSellColor("#FCEB3C")
            .setDirection(item.entry.type === "compra" ? "buy" : "sell")
            .setTime(item.entry.time / 1000)
            .setArrowHeight(15)
            .setArrowSpacing(5)
            .setPrice(item.entry.price);

          const executionShape2 = this.widget
            ?.activeChart()
            .createExecutionShape()
            .setText(`${item.exit.type}: ${item.exit.price}`)
            .setTextColor("#FCEB3C")
            .setArrowBuyColor("#FCEB3C")
            .setArrowSellColor("#FCEB3C")
            .setDirection(item.exit.type === "compra" ? "buy" : "sell")
            .setTime(item.exit.time / 1000)
            .setArrowHeight(15)
            .setArrowSpacing(5)
            .setPrice(item.exit.price);

          this.arrayExecutionShape.push(executionShape1);
          this.arrayExecutionShape.push(executionShape2);

          this.widget?.activeChart().createShape(
            {
              time: item.entry.time / 1000,
              price: item.entry.price,
              channel: item.entry.type === "compra" ? "low" : "high",
            },
            {
              shape: item.entry.type === "compra" ? "arrow_up" : "arrow_down",
              text: "",
            }
          );
          this.widget?.activeChart().createShape(
            {
              time: item.exit.time / 1000,
              price: item.exit.price,
              channel: item.exit.type === "compra" ? "low" : "high",
            },
            {
              shape: item.exit.type === "compra" ? "arrow_up" : "arrow_down",
              text: "",
            }
          );

          const pointShape = this.widget?.activeChart().createMultipointShape(
            [
              { time: Number(item.exit.time / 1000), price: item.exit.price },
              { time: Number(item.entry.time / 1000), price: item.entry.price },
            ],
            {
              shape: "trend_line",
              zOrder: "top",
              text: "text",
              overrides: {
                linecolor: "#FCEB3C",
                linewidth: 2,
                statsPosition: 3,
                linestyle: 1, // [0 (solid), 1 (dotted), 2 (dashed), 3 (large dashed)]
              },
            }
          );
          this.arrayMultipointShape.push(pointShape);
        });

        this.widget?.onChartReady(() => {
          // this.widgetVerticalLine(params.start_time / 1000, "#17c177"); //verde
          // this.widgetVerticalLine(params.limit_time / 1000, "#E5D860"); //amarelo
          // this.widgetVerticalLine(params.end_time / 1000, "#dd5b5b"); //vermelho

          this.widgetHorizontalLine(open.positions);
          this.widgetHorizontalLine(open.orders);
        });
      } catch (error) {
        console.log("error=", error);
      }
    },
    resetHistoricalDataAndRedrawChart(symbol, timeframe) {
      // onResetCacheNeededCallback é usado quando preciso atualizar os dados do histórico
      EventBus.$emit("DATAFEED_RESET_CACHE_TO_UPDATE_HISTORICAL_DATA", {
        symbol,
        timeframe,
        contextUuid: this.contextUuid,
      });
      // Redesenha o gráfico
      this.widget?.activeChart().resetData();
    },
  },
};
</script>

<style lang="scss" scoped></style>
